import React from 'react';
import { Box } from '@mui/material';
import SimulationGauge from '../../../components/SimulationGauge';

function DTSimulationGauge({ theme }) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
      <SimulationGauge theme={theme} fillContainer />
    </Box>
  );
}

export default React.memo(DTSimulationGauge);
